/* Armored Alpha chat widget. Config comes from window.AA_CHAT = { endpoint }. */
(function () {
  "use strict";
  var cfg = window.AA_CHAT || {};
  if (!cfg.endpoint || window.__aaChatLoaded) return;
  window.__aaChatLoaded = true;

  var STORE_KEY = "aa-chat-v1";
  var GREETING = "Hey! I'm the Armored Alpha assistant. Ask me about tick and mosquito protection, hunting gear, or shipping and returns.";
  var STARTERS = ["What keeps ticks off kids on hikes?", "Shipping and returns?", "Help me pick hunting optics"];

  var state = load() || { open: false, messages: [] };
  var busy = false;

  function load() {
    try { var s = JSON.parse(sessionStorage.getItem(STORE_KEY)); return s && Array.isArray(s.messages) ? s : null; } catch (e) { return null; }
  }
  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ open: state.open, messages: state.messages.slice(-30) })); } catch (e) {}
  }

  var CSS = [
    ":host{all:initial;--bg:#0F0F10;--panel:#161618;--forest:#14261A;--cream:#F5F1E8;--muted:rgba(245,241,232,.66);--line:rgba(245,241,232,.14);--amber:#E3B04B;--amber-ink:#1a1408;",
    "--head:'Big Shoulders Display',Impact,'Arial Narrow',sans-serif;--mono:'IBM Plex Mono',ui-monospace,Menlo,monospace;--body:var(--aa-body-font,'Public Sans',system-ui,-apple-system,'Segoe UI',sans-serif)}",
    "*{box-sizing:border-box}",
    ".launch{position:fixed;right:20px;bottom:20px;z-index:2147483000;display:flex;align-items:center;gap:10px;height:52px;padding:0 20px 0 16px;border:0;border-radius:999px;background:var(--amber);color:var(--amber-ink);font:600 15px/1 var(--body);letter-spacing:.01em;cursor:pointer;box-shadow:0 8px 24px rgba(0,0,0,.35)}",
    ".launch:hover{filter:brightness(1.06)}.launch:focus-visible,button:focus-visible,textarea:focus-visible,a:focus-visible{outline:2px solid var(--cream);outline-offset:2px}",
    ".launch svg{width:22px;height:22px;flex:none}",
    ".panel{position:fixed;right:20px;bottom:84px;z-index:2147483001;width:380px;max-width:calc(100vw - 32px);height:min(600px,calc(100vh - 110px));display:flex;flex-direction:column;background:var(--bg);color:var(--cream);border:1px solid var(--line);border-radius:14px;overflow:hidden;box-shadow:0 18px 50px rgba(0,0,0,.5);font:15px/1.5 var(--body);transform-origin:bottom right;animation:pop .18s ease-out}",
    ".panel[hidden]{display:none}",
    "@keyframes pop{from{opacity:0;transform:translateY(8px) scale(.98)}to{opacity:1;transform:none}}",
    "header{display:flex;align-items:center;gap:12px;padding:14px 14px 14px 18px;background:var(--forest);border-bottom:1px solid var(--line)}",
    "header .t{flex:1;min-width:0}header h2{margin:0;font:700 22px/1 var(--head);letter-spacing:.02em;text-transform:uppercase;color:var(--cream)}",
    "header p{margin:4px 0 0;font:500 11px/1.2 var(--mono);letter-spacing:.08em;text-transform:uppercase;color:var(--amber)}",
    ".icon{display:grid;place-items:center;width:36px;height:36px;border:0;border-radius:8px;background:transparent;color:var(--cream);cursor:pointer}.icon:hover{background:rgba(245,241,232,.08)}.icon svg{width:18px;height:18px}",
    ".log{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px;overscroll-behavior:contain}",
    ".msg{max-width:88%;padding:10px 13px;border-radius:12px;white-space:normal;overflow-wrap:anywhere}",
    ".bot{align-self:flex-start;background:var(--panel);border:1px solid var(--line);border-bottom-left-radius:4px}",
    ".user{align-self:flex-end;background:var(--cream);color:#151515;border-bottom-right-radius:4px}",
    ".msg p{margin:0 0 .5em}.msg p:last-child{margin:0}.msg ul{margin:.25em 0 .5em;padding-left:1.2em}.msg li{margin:.15em 0}",
    ".msg a{color:var(--amber);text-decoration:underline;text-underline-offset:2px}.msg strong{font-weight:700}",
    ".err{border-color:rgba(255,120,100,.5)}",
    ".dots{display:inline-flex;gap:4px;padding:4px 0}.dots i{width:6px;height:6px;border-radius:50%;background:var(--muted);animation:b 1s infinite ease-in-out}.dots i:nth-child(2){animation-delay:.15s}.dots i:nth-child(3){animation-delay:.3s}",
    "@keyframes b{0%,80%,100%{opacity:.3;transform:translateY(0)}40%{opacity:1;transform:translateY(-3px)}}",
    ".chips{display:flex;flex-wrap:wrap;gap:8px;padding:0 16px 12px}",
    ".chip{border:1px solid var(--line);background:transparent;color:var(--cream);border-radius:999px;padding:7px 12px;font:500 13px/1.2 var(--body);cursor:pointer;text-align:left}.chip:hover{border-color:var(--amber);color:var(--amber)}",
    "form{display:flex;align-items:flex-end;gap:8px;padding:12px;border-top:1px solid var(--line);background:var(--bg)}",
    "textarea{flex:1;resize:none;overflow-y:hidden;max-height:120px;min-height:42px;padding:10px 12px;border:1px solid var(--line);border-radius:10px;background:var(--panel);color:var(--cream);font:15px/1.4 var(--body)}textarea::placeholder{color:var(--muted)}",
    ".send{display:grid;place-items:center;width:42px;height:42px;flex:none;border:0;border-radius:10px;background:var(--amber);color:var(--amber-ink);cursor:pointer}.send:disabled{opacity:.45;cursor:default}.send svg{width:18px;height:18px}",
    ".foot{padding:0 12px 10px;font:500 10.5px/1.3 var(--mono);letter-spacing:.04em;color:var(--muted);text-align:center}",
    ".sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}",
    "@media (max-width:520px){.panel{right:0;bottom:0;width:100vw;max-width:100vw;height:100%;max-height:100dvh;border-radius:0;border:0}.launch.hide{display:none}}",
    "@media (prefers-reduced-motion:reduce){.panel{animation:none}.dots i{animation:none;opacity:.7}}"
  ].join("");

  var ICON_CHAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_SEND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var ICON_RESET = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>';

  var host = document.createElement("div");
  host.id = "aa-chat";
  var bodyFont = getComputedStyle(document.body).fontFamily;
  if (bodyFont) host.style.setProperty("--aa-body-font", bodyFont);
  var root = host.attachShadow({ mode: "open" });
  root.innerHTML =
    "<style>" + CSS + "</style>" +
    '<button class="launch" type="button" aria-controls="aa-panel" aria-expanded="false">' + ICON_CHAT + "<span>Ask us</span></button>" +
    '<section class="panel" id="aa-panel" role="dialog" aria-label="Armored Alpha chat" hidden>' +
    '<header><div class="t"><h2>Armored Alpha</h2><p>Gear help · AI assistant</p></div>' +
    '<button class="icon reset" type="button" aria-label="Start a new chat" title="New chat">' + ICON_RESET + "</button>" +
    '<button class="icon close" type="button" aria-label="Close chat">' + ICON_CLOSE + "</button></header>" +
    '<div class="log" role="log" aria-live="polite"></div>' +
    '<div class="chips"></div>' +
    '<form><label class="sr" for="aa-input">Message</label><textarea id="aa-input" rows="1" maxlength="1500" placeholder="Ask about a product, shipping…"></textarea>' +
    '<button class="send" type="submit" aria-label="Send">' + ICON_SEND + "</button></form>" +
    '<div class="foot">AI answers can be wrong. Check product pages for details.</div>' +
    "</section>";

  var $ = function (s) { return root.querySelector(s); };
  var launch = $(".launch"), panel = $(".panel"), log = $(".log"), chips = $(".chips"), form = $("form"), input = $("textarea"), send = $(".send");

  function esc(s) { return s.replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  function safeHref(url) {
    try {
      var u = new URL(url, location.origin);
      var h = u.hostname.replace(/^www\./, "");
      if (u.protocol === "https:" && (h === "armoredalpha.com" || u.hostname === location.hostname)) {
        // Keep shoppers on the domain they're browsing (preview themes, myshopify).
        if (u.hostname !== location.hostname) { u.protocol = location.protocol; u.host = location.host; }
        return u.href;
      }
    } catch (e) {}
    return null;
  }

  function inline(s) {
    s = esc(s);
    s = s.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (m, text, url) {
      var href = safeHref(url.replace(/&amp;/g, "&"));
      return href ? '<a href="' + esc(href) + '">' + text + "</a>" : text;
    });
    s = s.replace(/(^|[\s(])(https:\/\/(?:www\.)?armoredalpha\.com\/[^\s<)]*)/g, function (m, pre, url) {
      var href = safeHref(url.replace(/&amp;/g, "&").replace(/[.,!?]$/, ""));
      return href ? pre + '<a href="' + esc(href) + '">' + url + "</a>" : m;
    });
    return s.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  }

  function md(text) {
    var out = [], list = null;
    text.split("\n").forEach(function (line) {
      var li = line.match(/^\s*(?:[-*•]|\d+\.)\s+(.*)$/);
      if (li) { if (!list) { list = []; } list.push("<li>" + inline(li[1]) + "</li>"); return; }
      if (list) { out.push("<ul>" + list.join("") + "</ul>"); list = null; }
      if (line.trim()) out.push("<p>" + inline(line.replace(/^#+\s*/, "")) + "</p>");
    });
    if (list) out.push("<ul>" + list.join("") + "</ul>");
    return out.join("");
  }

  function bubble(role, text, cls) {
    var el = document.createElement("div");
    el.className = "msg " + (role === "user" ? "user" : "bot") + (cls ? " " + cls : "");
    if (role === "user") el.textContent = text; else el.innerHTML = md(text);
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function renderAll() {
    log.innerHTML = "";
    bubble("assistant", GREETING);
    state.messages.forEach(function (m) { bubble(m.role, m.content); });
    chips.innerHTML = "";
    if (!state.messages.length) {
      STARTERS.forEach(function (q) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "chip"; b.textContent = q;
        b.addEventListener("click", function () { ask(q); });
        chips.appendChild(b);
      });
    }
  }

  function setOpen(open, focus) {
    state.open = open;
    panel.hidden = !open;
    launch.setAttribute("aria-expanded", String(open));
    launch.classList.toggle("hide", open);
    launch.querySelector("span").textContent = open ? "Close" : "Ask us";
    save();
    if (open) { log.scrollTop = log.scrollHeight; if (focus) input.focus(); }
    else if (focus) launch.focus();
  }

  function setBusy(b) { busy = b; send.disabled = b; }

  function ask(text) {
    text = text.trim();
    if (!text || busy) return;
    chips.innerHTML = "";
    state.messages.push({ role: "user", content: text });
    save();
    bubble("user", text);
    input.value = ""; autosize();
    setBusy(true);

    var el = bubble("assistant", "");
    el.innerHTML = '<span class="dots" aria-label="Typing"><i></i><i></i><i></i></span>';
    var reply = "";

    fetch(cfg.endpoint, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ messages: state.messages.slice(-20) })
    }).then(function (res) {
      if (!res.ok || !res.body) {
        return res.text().then(function (t) { throw new Error(res.status === 429 ? t : "http " + res.status); });
      }
      var reader = res.body.getReader(), dec = new TextDecoder();
      function pump() {
        return reader.read().then(function (r) {
          if (r.done) return;
          reply += dec.decode(r.value, { stream: true });
          el.innerHTML = md(reply);
          log.scrollTop = log.scrollHeight;
          return pump();
        });
      }
      return pump();
    }).then(function () {
      reply = reply.trim();
      if (!reply) throw new Error("empty");
      state.messages.push({ role: "assistant", content: reply });
      save();
    }).catch(function (err) {
      var msg = err && /too quickly/.test(err.message) ? err.message : "Sorry, I couldn't connect just now. Please try again in a moment.";
      el.className = "msg bot err";
      el.innerHTML = md(reply ? reply + "\n\n" + msg : msg);
      // Drop the unanswered question so the transcript stays user/assistant alternating.
      if (!reply) state.messages.pop(); else state.messages.push({ role: "assistant", content: reply });
      save();
    }).then(function () { setBusy(false); input.focus(); });
  }

  function autosize() {
    input.style.height = "auto";
    input.style.height = Math.min(input.scrollHeight + 2, 120) + "px";
    input.style.overflowY = input.scrollHeight > 120 ? "auto" : "hidden";
  }

  launch.addEventListener("click", function () { setOpen(panel.hidden, true); });
  $(".close").addEventListener("click", function () { setOpen(false, true); });
  $(".reset").addEventListener("click", function () { if (busy) return; state.messages = []; save(); renderAll(); input.focus(); });
  form.addEventListener("submit", function (e) { e.preventDefault(); ask(input.value); });
  input.addEventListener("input", autosize);
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey && !e.isComposing) { e.preventDefault(); ask(input.value); }
  });
  panel.addEventListener("keydown", function (e) { if (e.key === "Escape") setOpen(false, true); });

  document.body.appendChild(host);
  renderAll();
  if (state.open && window.matchMedia("(min-width: 521px)").matches) setOpen(true, false);
})();
